<template>
  <v-form ref="form" @submit.prevent="submit" v-model="formValid">
    <v-row data-cy="forgot-form">
      <v-col cols="12" class="mt-8">
        <p class="mb-0 forgot__subtitle details-policy__value primary--text">
          <BaseButton
            class="title-font justify-start mr-2"  
            icon
            width="17"
            @click="$emit('go-back')">
            <img style="filter: invert(100%)" src="@/assets/ic_head_voltar_branco.svg" />
          </BaseButton>
          Recuperar senha
        </p>
      </v-col>
      <v-col cols="12" class="mt-4">
        <p class="mb-0 forgot__instruction details-policy__value primary--text">
          Digite seu e-mail cadastrado para enviarmos os próximos passos de
          recuperação da sua senha
        </p>
      </v-col>
      <v-col cols="12" class="mt-5">
        <BaseFormInput
          class="forgot__form-input"
          id-element="usernameLogin"
          placeholder="usuario@email.com"
          v-model="email"
          required
          :rules="[requiredInput, isValidEmail]"
          label-text="E-mail"
          :upper-case="false"
          v-on:keyup.enter="submit()"
        />
      </v-col>
      <v-col cols="12" class="my-8">
        <BaseButton
          v-html="'ENVIAR'"
          class="secondary font-weight-bold white--text"
          width="100%"
          @click="submit()"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { requiredInput, isValidEmail } from "@/utils/rules.js";
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  data: () => ({
    formValid: true,
    requiredInput,
    email: "",
    isValidEmail
  }),
  mixins: [LoadingRequest],
  methods: {
    ...mapActions("auth", ["requestForgotPassword"]),
    submit() {
      if (this.$refs.form.validate()) {
        this.withLoading(this.requestForgotPassword({ email: this.email }))
          .then(() => {
            this.showAlertNotification({
              message: "E-mail enviado com sucesso.",
              type: "success"
            });
            this.$emit("go-back");
          })
          .catch(error => {
            this.showAlertNotification({
              message: !error.response
                ? "Aconteceu um erro"
                : error.response.data.details &&
                  error.response.data.details.length > 0
                ? error.response.data.details.reduce(
                    (acc, { message }) => acc.concat(message),
                    ""
                  )
                : error.response.data.error_description,
              type: "error"
            });
          });
      }
    }
  }
};
</script>
<style lang="sass">
.forgot
  &__subtitle
    font-size: 18px
    font-weight: 600
  &__instruction
    font-size: 14px
    line-height: 18px
  &__form-input
    label.form__label.primary--text
      color: white !important
</style>
